<template>
  <div class="auth-page">
    <div class="auth-container">
      <div class="auth-logo">
        <a href="/">
          <img :src="logoUrl" alt="Ibomstore" />
        </a>
      </div>
      
      <div class="auth-card">
        <div class="auth-header">
          <h1>Create Account</h1>
          <p>Sign up to start shopping</p>
        </div>

        <form @submit.prevent="handleRegister" class="auth-form">
          <div class="form-row">
            <div class="form-group">
              <label>First Name *</label>
              <input v-model="form.first_name" type="text" placeholder="First name" required>
              <span v-if="errors.first_name" class="error">{{ errors.first_name[0] }}</span>
            </div>
            <div class="form-group">
              <label>Last Name *</label>
              <input v-model="form.last_name" type="text" placeholder="Last name" required>
              <span v-if="errors.last_name" class="error">{{ errors.last_name[0] }}</span>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>Email Address *</label>
              <input v-model="form.email" type="email" placeholder="Enter your email" required>
              <span v-if="errors.email" class="error">{{ errors.email[0] }}</span>
            </div>
            <div class="form-group">
              <label>Phone Number *</label>
              <input v-model="form.mobile" type="tel" placeholder="Phone number" required>
              <span v-if="errors.mobile" class="error">{{ errors.mobile[0] }}</span>
            </div>
          </div>

          <div class="form-group">
            <label>State *</label>
            <select v-model="form.state_id">
              <option value="">Select your state</option>
              <option v-for="state in states" :key="state.id" :value="state.id">{{ state.name }}</option>
            </select>
            <span v-if="errors.state_id" class="error">{{ errors.state_id[0] }}</span>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>Password *</label>
              <div class="password-input-wrapper">
                <input v-model="form.password" :type="showPassword ? 'text' : 'password'" placeholder="Password" required>
                <button type="button" class="password-toggle" @click="showPassword = !showPassword">
                  <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                </button>
              </div>
              <span v-if="errors.password" class="error">{{ errors.password[0] }}</span>
            </div>
            <div class="form-group">
              <label>Confirm Password *</label>
              <div class="password-input-wrapper">
                <input v-model="form.password_confirmation" :type="showConfirmPassword ? 'text' : 'password'" placeholder="Confirm password" required>
                <button type="button" class="password-toggle" @click="showConfirmPassword = !showConfirmPassword">
                  <i :class="showConfirmPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                </button>
              </div>
            </div>
          </div>

          <button type="submit" class="btn-submit" :disabled="loading">
            {{ loading ? 'Creating Account...' : 'Sign Up' }}
          </button>

          <GoogleLoginButton 
            mode="register"
            button-text="Sign up with Google"
            loading-text="Signing up..."
            @success="onGoogleSuccess"
            @error="onGoogleError"
            @loading="onGoogleLoading"
          />
        </form>

        <div class="auth-footer">
          <p>Already have an account? 
            <a href="/login">Login</a>
          </p>
        </div>

        <div v-if="successMessage" class="rounded-md border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-700">
          {{ successMessage }}
        </div>
        
        <div v-if="errorMessage" class="rounded-md border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-700">
          {{ errorMessage }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GoogleLoginButton from '../../components/auth/GoogleLoginButton.vue'

export default {
  name: 'Register',
  components: {
    GoogleLoginButton
  },
  props: {
    states: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      logoUrl: '/logos/logodark.svg',
      form: {
        first_name: '',
        last_name: '',
        email: '',
        mobile: '',
        state_id: '',
        password: '',
        password_confirmation: ''
      },
      showPassword: false,
      showConfirmPassword: false,
      errors: {},
      loading: false,
      successMessage: '',
      errorMessage: ''
    }
  },
  methods: {
    async handleRegister() {
      this.loading = true
      this.errors = {}
      this.errorMessage = ''
      this.successMessage = ''
      
      try {
        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
        
        const response = await fetch('/register', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': csrfToken,
            'Accept': 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify(this.form)
        })
        
        const data = await response.json()
        
        if (response.ok) {
          this.successMessage = 'Registration successful! Redirecting...'
          setTimeout(() => {
            window.location.href = data.redirect || '/'
          }, 500)
        } else {
          if (data.errors) {
            this.errors = data.errors
          }
        }
      } catch (error) {
        this.errorMessage = 'An error occurred. Please try again.'
      } finally {
        this.loading = false
      }
    },

    onGoogleSuccess(message) {
      this.successMessage = message
    },

    onGoogleError(message) {
      this.errorMessage = message
    },

    onGoogleLoading(isLoading) {
      this.loading = isLoading
    }
  }
}
</script>

